import {AdminComponent} from './layout/admin/admin.component';
import {AppComponent} from './app.component';
import {AuthComponent} from './layout/auth/auth.component';
import {AuthenticationService} from './shared/Services/authentication.service';
import {BreadcrumbsComponent} from './layout/admin/breadcrumbs/breadcrumbs.component';
import {BroadcastService} from './shared/Services/broadcast.service';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {ClassicBoxComponent} from './shared/components/classic-box/classic-box.component';
import {ChildItemComponent} from './shared/components/child-item/child-item.component';
import {DashboardBackOfficeComponent} from './back-office/Components/dashboard/dashboard-back-office.component';
import {DashboardComponent} from './dealer-system/Components/dashboard/dashboard.component';
import {DateService} from './shared/Services/date.service';
import {DomainSelectComponent} from './translation/Components/domain-select/domain-select.component';
import {DomainService} from './translation/Services/domain-service.service';
import {EmailOverviewComponent} from './back-office/Components/email-component/email-overview/email-overview.component';
import {EmailService} from './back-office/Services/email.service';
import {environment} from '../environments/environment';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {FormlyFieldButton} from './button-type.component';
import {FormlyModule} from '@ngx-formly/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {GridComponent} from './shared/components/grid/grid.component';
import {Helper} from './helpers/helper.service';
import {HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {LanguageListComponent} from './back-office/Components/localization/language-list/language-list.component';
import {LanguageService} from './translation/Services/language.service';
import {APP_INITIALIZER, ErrorHandler, Injectable, LOCALE_ID, NgModule} from '@angular/core';
import {LocalizationLabelComponent} from './back-office/Components/localization/localization-label/localization-label.component';
import {LocalizationOverviewComponent} from './back-office/Components/localization/localization-overview/localization-overview.component';
import {LocalizationService} from './back-office/Services/localization.service';
import {LoginComponent} from './auth/login/login.component';
import {ManageEmailComponent} from './back-office/Components/email-component/manage-email/manage-email.component';
import {ManageSystemUsersComponent} from './back-office/Components/system-users/manage-system-users/manage-system-users.component';
import {MenuItems} from './shared/menu-items/menu-items';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {QuillModule} from 'ngx-quill';
import {AppRoutingModule} from './routing';
import {NgSelectModule} from '@ng-select/ng-select';
import {SharedModule} from './shared/shared.module';
import {SystemUsersOverviewComponent} from './back-office/Components/system-users/system-users-overview/system-users-overview.component';
import {ToastService} from './shared/Services/toast.service';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {TranslationService} from './translation/Services/translation.service';
import {UsersService} from './back-office/Services/users.service';
import {DealersService} from './back-office/Services/dealers.service';
import {ManageCollectionComponent} from './back-office/Components/collection/manage-collection/manage-collection.component';
import {CollectionOverviewComponent} from './back-office/Components/collection/collection-overview/collection-overview.component';
import {CollectionService} from './back-office/Services/collection.service';
import {ModelService} from './back-office/Services/model.service';
import {ManageProductComponent} from './back-office/Components/product/manage-product/manage-product.component';
import {ProductService} from './back-office/Services/product.service';
import {ManageModelComponent} from './back-office/Components/model/manage-model/manage-model.component';
import {ModelOverviewComponent} from './back-office/Components/model/modal-overview/model-overview.component';
import {FormlyFieldNgSelectComponent} from './types/ng-select.type.component';
import {ProductOverviewComponent} from './back-office/Components/product/product-overview/product-overview.component';
import {TranslationFormlyService} from './back-office/Services/translation.formly.service';
import {ViewCollectionComponent} from './back-office/Components/collection/view-collection/view-collection.component';
import {ViewModelComponent} from './back-office/Components/model/view-model/view-model.component';
import {SubProductService} from './back-office/Services/sub.product.service';
import {ForgetPasswordComponent} from './auth/forget-password/forget-password.component';
import {TaxService} from './back-office/Services/tax.service';
import {SuccessForgetPasswordComponent} from './auth/success-forget-password/success-forget-password.component';
import {DealerOverviewComponent} from './back-office/Components/dealer/dealer-overview/dealer-overview.component';
import {ManageDealerComponent} from './back-office/Components/dealer/manage-dealer/manage-dealer.component';
import {ResetPasswordComponent} from './auth/reset-password/reset-password.component';
import {EqualValidatorDirective} from './shared/directives/equal-validator.directive';
import {CountryService} from './translation/Services/Country.service';
import {ManageOrderComponent} from './shared/order/manage-order/manage-order.component';
import {OrderService} from './dealer-system/Services/order.service';
import {ServiceRequestService} from './dealer-system/Services/service-request.service';
import {SuccessOrderComponent} from './dealer-system/Components/success-order/success-order.component';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {CurrencyPipe} from '@angular/common';
import {PropertyOverviewComponent} from './back-office/Components/property/property-overview/property-overview.component';
import {PropertyService} from './back-office/Services/property.service';
import {ManagePropertyComponent} from './back-office/Components/property/manage-property/manage-property.component';
import {FabricCollectionComponent} from './back-office/Components/fabric-collection/fabric-collection-overview/fabric-collection.component';
import {ManageFabricCollectionComponent} from './back-office/Components/fabric-collection/manage-fabric-collection/manage-fabric-collection.component';
import {FabricCollectionService} from './back-office/Services/fabric-collection.service';
import {FabricViewComponent} from './back-office/Components/fabric/fabric-view/fabric-view.component';
import {FabricService} from './back-office/Services/fabric.service';
import {ViewFabricCollectionComponent} from './back-office/Components/fabric-collection/view-fabric-collection/view-fabric-collection.component';
import {ManageFabricComponent} from './back-office/Components/fabric/manage-fabric/manage-fabric.component';
import {SupplierOverviewComponent} from './back-office/Components/supplier/supplier-overview/supplier-overview.component';
import {SupplierService} from './back-office/Services/supplier.service';
import {ManageSupplierComponent} from './back-office/Components/supplier/manage-supplier/manage-supplier.component';
import {ViewSupplierComponent} from './back-office/Components/supplier/view-supplier/view-supplier.component';
import {ManageOptionComponent} from './back-office/Components/option/manage-option/manage-option.component';
import {OptionService} from './back-office/Services/option.service';
import {OptionOverviewComponent} from './back-office/Components/option/option-overview/option-overview.component';
import {ViewOptionComponent} from './back-office/Components/option/view-option/view-option.component';
import {FabricColorService} from './back-office/Services/fabric-color.service';
import {ArchiveSupplierViewComponent} from './back-office/Components/supplier/archive-supplier-view/archive-supplier-view.component';
import {ArchivePropertyViewComponent} from './back-office/Components/property/archive-property-view/archive-property-view.component';
import {ArchiveFabricCollectionViewComponent} from './back-office/Components/fabric-collection/archive-fabric-collection-view/archive-fabric-collection-view.component';
import {ArchiveCollectionViewComponent} from './back-office/Components/collection/archive-collection-view/archive-collection-view.component';
import {FileUploadModule} from 'ng2-file-upload';
import {ArchiveModelViewComponent} from './back-office/Components/model/archive-model-view/archive-model-view.component';
import {ArchiveOptionViewComponent} from './back-office/Components/option/archive-option-view/archive-option-view.component';
import {ManageLanguageComponent} from './back-office/Components/localization/manage-language/manage-language.component';
import {ArchiveProductViewComponent} from './back-office/Components/product/archive-product-view/archive-product-view.component';
import {ViewProductComponent} from './back-office/Components/product/view-product/view-product.component';
import {OrderOverviewComponent} from './dealer-system/Components/order/order-overview/order-overview.component';
import {DealerServiceRequestOverviewComponent} from './dealer-system/Components/service/service-request-overview/service-request-overview.component';
import {ViewOrderComponent} from './dealer-system/Components/order/view-order/view-order.component';
import {QuoteOverviewComponent} from './dealer-system/Components/quote/quote-overview/quote-overview.component';
import {ViewQuoteComponent} from './dealer-system/Components/quote/view-quote/view-quote.component';
import {ArchiveDealerViewComponent} from './back-office/Components/dealer/archive-dealer-view/archive-dealer-view.component';
import {ViewBillingAccountComponent} from './back-office/Components/dealer/view-billing-account/view-billing-account.component';
import {ManageDownloadComponent} from './back-office/Components/download/manage-download/manage-download.component';
import {DownloadOverviewComponent} from './back-office/Components/download/download-overview/download-overview.component';
import {DownloadService} from './back-office/Services/download.service';
import {ManageServiceRequestComponent} from './shared/service-request/manage-service-request/manage-service-request.component';
import {ManageServiceRemarkComponent} from './shared/service-remark/manage-service-remark/manage-service-remark.component';
import {AccountOverviewComponent} from './dealer-system/Components/account/account-overview/account-overview.component';
import {ManageUserComponent} from './dealer-system/Components/account/manage-user/manage-user.component';
import {DownloadFilesService} from './back-office/Services/download-files.service';
import {DownloadsOverviewComponent} from './dealer-system/Components/download/downloads-overview/downloads-overview.component';
import {InvoiceComponent} from './dealer-system/Components/invoice/invoice.component';
import {CountryOverviewComponent} from './back-office/Components/country/country-overview/country-overview.component';
import {ManageCountryComponent} from './back-office/Components/country/manage-country/manage-country.component';
import {BackofficeViewOrderComponent} from './back-office/Components/order/backoffice-view-order/backoffice-view-order.component';
import {BackofficeOrderOverviewComponent} from './back-office/Components/order/order-overview/backoffice-order-overview.component';
import {BackofficePosRegistrationOverviewComponent} from './back-office/Components/order/pos-registration-overview/backoffice-pos-registration-overview.component';
import { ManageExchangeComponent } from './back-office/Components/order/exchange/manage-exchange/manage-exchange.component';
import {
  BackofficeExchangeOverviewComponent
} from './back-office/Components/order/exchange/exchange-overview/backoffice-exchange-overview.component';
import {BackofficeOverviewQuoteComponent} from './back-office/Components/quote/quote-overview/quote-overview.component';
import {BackofficeViewQuoteComponent} from './back-office/Components/quote/view-quote/view-quote.component';
import {BackOfficeOrderService} from './back-office/Services/order.service';
import {ManageDeliveryDealerComponent} from './back-office/Components/dealer/manage-delivery-dealer/manage-delivery-dealer.component';
import {NgbdDatepickerConfigComponent} from './shared/order/manage-order/delivery-week/delivery-week';
import {ViewDeliveryDealerComponent} from './back-office/Components/dealer/view-delivery-dealer/view-delivery-dealer.component';
import {ManageDealerUserComponent} from './back-office/Components/dealer/view-delivery-dealer/manage-dealar-user/manage-dealer-user.component';
import {BackofficeInvoiceOverviewComponent} from './back-office/Components/invoice/backoffice-invoice-overview/backoffice-invoice-overview.component';
import {BackofficeDrafyInvoiceOverviewComponent} from './back-office/Components/invoice draft/backoffice-draft-invoice-overview/backoffice-draft-invoice-overview.component';
import {BackofficeDraftInvoiceViewComponent} from './back-office/Components/invoice draft/backoffice-draft-invoice-view/backoffice-draft-invoice-view.component';
import {DraftInvoiceLogsOverviewComponent} from './back-office/Components/draft-invoice-logs/draft-invoice-logs-overview/draft-invoice-logs-overview.component';
import {ExportComponent} from './back-office/Components/export/export.component';
import {BackOfficeInvoiceService} from './back-office/Services/invoice.service';
import {InvoiceService} from './dealer-system/Services/invoice.service';
import {ManageDealerPointsComponent} from './back-office/Components/dealer-points/manage-dealer-points/manage-dealer-points.component';
import {DealerTypeService} from './back-office/Services/dealer-type.service';
import {ManageGeneralTermComponent} from './back-office/Components/general-terms/manage-general-term/manage-general-term.component';
import {GeneralTermsOverviewComponent} from './back-office/Components/general-terms/general-term-overview/general-terms-overview.component';
import {GeneralTermService} from './back-office/Services/general-term.service';
import {CreditInvoiceOverviewComponent} from './back-office/Components/credit-invoice/credit-invoice-overview/credit-invoice-overview.component';
import {CreditInvoiceService} from './back-office/Services/creditInvoice.service';
import {CreditInvoiceComponent} from './back-office/Components/invoice/backoffice-invoice-overview/credit-invoice/credit-invoice.component';
import {BackofficeCurrencyPipe} from './pipe/backoffice-currency.pipe';
import {AcceptTermComponent} from './auth/accept-term/accept-term.component';
import {ManageStyleComponent} from './back-office/Components/style/manage-style/manage-style.component';
import {StyleOverviewComponent} from './back-office/Components/style/style-overview/style-overview.component';
import {StyleService} from './back-office/Services/style.service';
import {StockProductComponent} from './back-office/Components/product/stock-product/stock-product.component';
import {ArchiveStyleViewComponent} from './back-office/Components/style/archive-style-view/archive-style-view.component';
import {DateFormatPipe} from './pipe/date-format.pipe';
import {TmsLogComponent} from './back-office/Components/product/tms-log/tms-log.component';
import {TmsLogService} from './back-office/Services/tms-log.service';
import {ArchiveStockProductComponent} from './back-office/Components/product/archive-stock-product/archive-stock-product.component';
import {WeekDateFormatPipe} from './pipe/week-date-format';
import {FabricFormatPipe} from './pipe/fabric-format.pipe';
import {PackagingLabelComponent} from './back-office/Components/packaging-label/packaging-label.component';
import {PackagingLabelService} from './back-office/Services/packaging-label.service';
import {OrderLogComponent} from './back-office/Components/product/order-log/order-log.component';
import {OrderLogService} from './back-office/Services/order-log.service';
import {LoadingBarHttpClientModule} from '@ngx-loading-bar/http-client';
import {DealerDashboardOverviewComponent} from './back-office/Components/dealer-dashboard/dealer-dashboard-overview/dealer-dashboard-overview.component';
import {DealerDashboardService} from './back-office/Services/dealer-dashboard.service';
import {ArchiveDealerDashboardComponent} from './back-office/Components/dealer-dashboard/archive-dealer-dashboard/archive-dealer-dashboard.component';
import {DashboardService} from './dealer-system/Services/dashboard.service';
import {ManageBlockComponent} from './back-office/Components/dealer-dashboard/manage-block/manage-block.component';
import {SafePipe} from './pipe/safe.pipe';
import {DataTableService} from './shared/Services/data-table.service';
import {InvoiceLayoutOverviewComponent} from './back-office/Components/invoice-layout/invoice-layout-overview/invoice-layout-overview.component';
import {InvoiceLayoutService} from './back-office/Services/invoice-layout.service';
import {ManageInvoiceLayoutComponent} from './back-office/Components/invoice-layout/manage-invoice-layout/manage-invoice-layout.component';
import {CollectionDiscountComponent} from './back-office/Components/collection-discount/collection-discount.component';
import { EmailLogComponent } from './back-office/Components/email-component/email-log/email-log.component';
import { DealerProfileOverviewComponent } from './back-office/Components/dealer-profile/dealer-profile-overview/dealer-profile-overview.component';
import { ManageDealerProfileComponent } from './back-office/Components/dealer-profile/manage-dealer-profile/manage-dealer-profile.component';
import {DealerProfileService} from './back-office/Services/dealer-profile.service';
import {ExactLogService} from './back-office/Services/exact-log.service';
import {ServiceSubjectService} from './back-office/Services/service-subject.service';
import { OrderGridComponent } from './dealer-system/Components/dashboard/order-grid/order-grid.component';
import { ManageTokenComponent } from './back-office/Components/exact/manage-token/manage-token.component';
import { DealerGridComponent } from './back-office/Components/dealer/view-dealer/dealer-grid/dealer-grid.component';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive';
import { LoginModalComponent } from './auth/login-modal/login-modal.component';
import { ServiceSubjectOverviewComponent } from './back-office/Components/service-subject/service-subject-overview/service-subject-overview.component';
import { ArchiveServiceSubjectComponent } from './back-office/Components/service-subject/archive-service-subject/archive-service-subject.component';
import { ManageServiceSubjectComponent } from './back-office/Components/service-subject/manage-service-subject/manage-service-subject.component';
import { ViewServiceSubjectComponent } from './back-office/Components/service-subject/view-service-subject/view-service-subject.component';
import { ServiceSubjectItemOverviewComponent } from './back-office/Components/service-subject/service-subject-item/service-subject-item-overview/service-subject-item-overview.component';
import { ServiceSubjectProductsComponent } from './back-office/Components/service-subject/service-subject-products/service-subject-products.component';
import { ServiceSubjectSolutionOverviewComponent } from './back-office/Components/service-subject/service-subject-solution/service-subject-solution-overview/service-subject-solution-overview.component';
import {ServiceSubjectItemService} from './back-office/Services/service-subject-item.service';
import { SolutionOverviewComponent } from './back-office/Components/solution/solution-overview/solution-overview.component';
import {SolutionService} from './back-office/Services/solution.service';
import { SolutionArchiveComponent } from './back-office/Components/solution/solution-archive/solution-archive.component';
import { ManageSolutionComponent } from './back-office/Components/solution/manage-solution/manage-solution.component';
import { ViewSolutionComponent } from './back-office/Components/solution/view-solution/view-solution.component';
import { SolutionTemplateComponent } from './back-office/Components/solution/solution-template/solution-template.component';
import { SolutionStepComponent } from './back-office/Components/solution/solution-template/solution-step/solution-step.component';
import { SolutionActionEmailComponent } from './back-office/Components/solution/solution-template/solution-step/solution-action-email/solution-action-email.component';
import { SolutionActionTextComponent } from './back-office/Components/solution/solution-template/solution-step/solution-action-text/solution-action-text.component';
import { SolutionActionConfirmationComponent } from './back-office/Components/solution/solution-template/solution-step/solution-action-confirmation/solution-action-confirmation.component';
import { SolutionActionFormComponent } from './back-office/Components/solution/solution-template/solution-step/solution-action-form/solution-action-form.component';
import { ServiceRequestOverviewComponent } from './back-office/Components/service-request/service-request-overview/service-request-overview.component';
import { ViewServiceRequestComponent } from './back-office/Components/service-request/view-service-request/view-service-request.component';
import { ManageRequestReplyComponent } from './back-office/Components/service-request/manage-request-reply/manage-request-reply.component';
import { SelectSolutionComponent } from './back-office/Components/service-request/manage-request-reply/select-solution/select-solution.component';
import { ReplyStepComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step.component';
import { ReplyStepFormComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step-form/reply-step-form.component';
import { ReplyStepConfirmationComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step-confirmation/reply-step-confirmation.component';
import { ReplyStepEmailComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step-email/reply-step-email.component';
import { ReplyStepTextComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step-text/reply-step-text.component';
import { ReplyStepInvoiceComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step-invoice/reply-step-invoice.component';
import { ReplyStepPackagingLabelComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step-packaging-label/reply-step-packaging-label.component';
import { ReplyStepReorderComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step-reorder/reply-step-reorder.component';
import { DealerViewServiceRequestComponent } from './dealer-system/Components/service/view-service-request/view-service-request.component';
import { ManageRequestReplyDealerComponent } from './dealer-system/Components/service/manage-request-reply-dealer/manage-request-reply-dealer.component';
import { DealerReplyStepComponent } from './dealer-system/Components/service/manage-request-reply-dealer/dealer-reply-step/dealer-reply-step.component';
import { DealerReplyStepConfirmationComponent } from './dealer-system/Components/service/manage-request-reply-dealer/dealer-reply-step/dealer-reply-step-confirmation/dealer-reply-step-confirmation.component';
import { DealerReplyStepFormComponent } from './dealer-system/Components/service/manage-request-reply-dealer/dealer-reply-step/dealer-reply-step-form/dealer-reply-step-form.component';
import { DealerReplyStepInvoiceComponent } from './dealer-system/Components/service/manage-request-reply-dealer/dealer-reply-step/dealer-reply-step-invoice/dealer-reply-step-invoice.component';
import { DealerReplyStepPackagingLabelComponent } from './dealer-system/Components/service/manage-request-reply-dealer/dealer-reply-step/dealer-reply-step-packaging-label/dealer-reply-step-packaging-label.component';
import { DealerReplyStepTextComponent } from './dealer-system/Components/service/manage-request-reply-dealer/dealer-reply-step/dealer-reply-step-text/dealer-reply-step-text.component';
import { DealerReplyStepReorderComponent } from './dealer-system/Components/service/manage-request-reply-dealer/dealer-reply-step/dealer-reply-step-reorder/dealer-reply-step-reorder.component';
import { GeneratePackagingLabelComponent } from './back-office/Components/packaging-label/generate-packaging-label/generate-packaging-label.component';
import { GenerateInvoiceComponent } from './back-office/Components/invoice/generate-invoice/generate-invoice.component';
import {EditorFormlyComponent} from './shared/components/editor-formly/editor-formly.component';
import {FileUploaderFormlyComponent} from './shared/components/file-uploader-formly/file-uploader-formly.component';
import { SolutionActionChangeStatusComponent } from './back-office/Components/solution/solution-template/solution-step/solution-action-change-status/solution-action-change-status.component';
import { ReplyStepChangeStatusComponent } from './back-office/Components/service-request/manage-request-reply/reply-step/reply-step-change-status/reply-step-change-status.component';
import { CollectionTransportationCostComponent } from './back-office/Components/collection-transportation_cost/collection-transportation-cost.component';
import { lowercaseValidator, uppercaseValidator, numberValidator, specialValidator, maxlengthValidationMessages, minlengthValidationMessages, requiredValidationMessages } from './helpers/password-validators';
import {ColliesFormComponent} from './back-office/Components/product/view-product/collies-form/collies-form.component';
import {
  ExactCrmUpdatesOverviewComponent
} from './back-office/Components/exact-logs/exact-crm-updates-overview/exact-crm-updates-overview.component';
import {ExactLogsOverviewComponent} from './back-office/Components/exact-logs/exact-logs-overview/exact-logs-overview.component';
import {ExchangeLogsOverviewComponent} from './back-office/Components/exchange-logs/exchange-logs-overview/exchange-logs-overview.component';
import {RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module, RECAPTCHA_LOADER_OPTIONS, ReCaptchaV3Service} from 'ng-recaptcha';
import {of} from 'rxjs';
import { RequestInterceptorService } from './shared/Services/request-interceptor.service';
import { VerifyCodeComponent } from './auth/verify-code/verify-code.component';
import { StorageService } from './auth/storage.service';
import { AccountSettingComponent } from './back-office/Components/account-setting/account-setting.component';
import {ExactRetriesOverviewComponent} from './back-office/Components/exact-logs/exact-retries-overview/exact-retries-overview.component';
import { CookieManagerService } from './shared/Services/cookie.service';
import {
  BillingAccountsOverviewComponent
} from './back-office/Components/dealer/billing-accounts-overview/billing-accounts-overview.component';
import {ViewDealerComponent} from './back-office/Components/dealer/view-dealer/view-dealer.component';
import {ManageDisclaimerComponent} from './back-office/Components/disclaimer/manage-disclaimer/manage-disclaimer.component';
import {DisclaimerService} from './back-office/Services/disclaimer.service';
import {DisclaimerOverviewComponent} from './back-office/Components/disclaimer/disclaimer-overview.component';
import {InternalPackagingLabelComponent} from './back-office/Components/internal-packaging-label/internal-packaging-label.component';
import {InternalPackagingLabelService} from './back-office/Services/internal-packaging-label.service';
import {ContactFunctionService} from './back-office/Services/contact-function.service';
import {ManageWorkFormItemComponent} from './back-office/Components/work-form-item/manage-work-form-item/manage-work-form-item.component';
import {WorkFormItemOverviewComponent} from './back-office/Components/work-form-item/work-form-item-overview.component';
import {WorkFormItemService} from './back-office/Services/work-form-item.service';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TreeviewI18n, DefaultTreeviewI18n } from '@paymate-software/ngx-treeview';
import {ManagePartsComponent} from './back-office/Components/parts/manage-parts/manage-parts.component';
import {ArchivePartsViewComponent} from './back-office/Components/parts/archive-parts-view/archive-parts-view.component';
import {PartsOverviewComponent} from './back-office/Components/parts/parts-overview/parts-overview.component';
import { PartsService } from './back-office/Services/parts.service';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';

Sentry.init({
  enabled: environment.production,
  dsn: environment.sentryDSN,
});

/**
 * Feature environments (<branch>-urbansofa-dev.idepardazanchapar.ir, e.g. ai-us-422-urbansofa-dev) are
 * created per branch, so none of them is on the Google site key and nobody could log in to test there.
 * The API pairs this with RECAPTCHA_ENABLED=false, set only by the Develop deploy target. The pattern is
 * anchored so dev, stage and live hosts never match.
 */
const FEATURE_ENV_HOST = /^[a-z0-9-]+-urbansofa-dev\.idepardazanchapar\.ir$/;
const recaptchaDisabled =
  environment.recaptchaEnabled === false || FEATURE_ENV_HOST.test(window.location.hostname);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.apiUrl + '/localization/', '.json');
}

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {
  }

  handleError(error) {
    if (!environment.production) {
      throw error;
    }
    return error;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    VerifyCodeComponent,
    EqualValidatorDirective,
    GridComponent,
    BackofficeCurrencyPipe,
    AdminComponent,
    AuthComponent,
    BreadcrumbsComponent,
    LoginComponent,
    DashboardBackOfficeComponent,
    DashboardComponent,
    DomainSelectComponent,
    LocalizationOverviewComponent,
    ClassicBoxComponent,
    ChildItemComponent,
    FormlyFieldButton,
    LanguageListComponent,
    LocalizationLabelComponent,
    ManageEmailComponent,
    EmailOverviewComponent,
    SystemUsersOverviewComponent,
    ManageSystemUsersComponent,
    ManageCollectionComponent,
    CollectionOverviewComponent,
    ManageModelComponent,
    ModelOverviewComponent,
    ManageProductComponent,
    FormlyFieldNgSelectComponent,
    ProductOverviewComponent,
    ViewCollectionComponent,
    ViewModelComponent,
    ForgetPasswordComponent,
    SuccessForgetPasswordComponent,
    DealerOverviewComponent,
    BillingAccountsOverviewComponent,
    ManageDealerComponent,
    ResetPasswordComponent,
    ManageOrderComponent,
    SuccessOrderComponent,
    PropertyOverviewComponent,
    ManagePropertyComponent,
    SupplierOverviewComponent,
    ManageSupplierComponent,
    ViewSupplierComponent,
    FabricCollectionComponent,
    ManageFabricCollectionComponent,
    FabricViewComponent,
    ViewFabricCollectionComponent,
    ManageFabricComponent,
    ManageOptionComponent,
    OptionOverviewComponent,
    ViewOptionComponent,
    ArchiveSupplierViewComponent,
    ArchivePropertyViewComponent,
    ArchiveFabricCollectionViewComponent,
    ArchiveCollectionViewComponent,
    ArchiveOptionViewComponent,
    ArchiveModelViewComponent,
    ManageLanguageComponent,
    ArchiveProductViewComponent,
    ViewProductComponent,
    OrderOverviewComponent,
    DealerServiceRequestOverviewComponent,
    ViewOrderComponent,
    QuoteOverviewComponent,
    ViewQuoteComponent,
    ArchiveDealerViewComponent,
    ViewDealerComponent,
    ViewBillingAccountComponent,
    ManageDownloadComponent,
    DownloadOverviewComponent,
    ManageServiceRequestComponent,
    ManageServiceRemarkComponent,
    DownloadsOverviewComponent,
    AccountOverviewComponent,
    ManageUserComponent,
    InvoiceComponent,
    CountryOverviewComponent,
    ManageCountryComponent,
    BackofficeOrderOverviewComponent,
    BackofficePosRegistrationOverviewComponent,
    ManageExchangeComponent,
    BackofficeExchangeOverviewComponent,
    BackofficeOverviewQuoteComponent,
    BackofficeViewQuoteComponent,
    BackofficeViewOrderComponent,
    ManageDeliveryDealerComponent,
    NgbdDatepickerConfigComponent,
    ViewDeliveryDealerComponent,
    ManageDealerUserComponent,
    BackofficeInvoiceOverviewComponent,
    BackofficeDrafyInvoiceOverviewComponent,
    BackofficeDraftInvoiceViewComponent,
    DraftInvoiceLogsOverviewComponent,
    ManageDealerUserComponent,
    ExportComponent,
    GeneralTermsOverviewComponent,
    ManageGeneralTermComponent,
    ManageDealerPointsComponent,
    CreditInvoiceOverviewComponent,
    CreditInvoiceComponent,
    AcceptTermComponent,
    CreditInvoiceComponent,
    ManageStyleComponent,
    StyleOverviewComponent,
    StockProductComponent,
    ArchiveStyleViewComponent,
    DateFormatPipe,
    TmsLogComponent,
    ArchiveStockProductComponent,
    WeekDateFormatPipe,
    FabricFormatPipe,
    PackagingLabelComponent,
    InternalPackagingLabelComponent,
    OrderLogComponent,
    EmailLogComponent,
    DealerDashboardOverviewComponent,
    ArchiveDealerDashboardComponent,
    ManageBlockComponent,
    SafePipe,
    InvoiceLayoutOverviewComponent,
    ManageInvoiceLayoutComponent,
    CollectionDiscountComponent,
    DealerProfileOverviewComponent,
    ExactLogsOverviewComponent,
    ExchangeLogsOverviewComponent,
    ExactCrmUpdatesOverviewComponent,
    ExactRetriesOverviewComponent,
    ManageDealerProfileComponent,
    OrderGridComponent,
    ManageTokenComponent,
    DealerGridComponent,
    LoginModalComponent,
    ServiceSubjectOverviewComponent,
    ArchiveServiceSubjectComponent,
    ManageServiceSubjectComponent,
    ViewServiceSubjectComponent,
    ServiceSubjectItemOverviewComponent,
    ServiceSubjectProductsComponent,
    ServiceSubjectSolutionOverviewComponent,
    SolutionOverviewComponent,
    SolutionArchiveComponent,
    ManageSolutionComponent,
    ViewSolutionComponent,
    SolutionTemplateComponent,
    SolutionStepComponent,
    SolutionActionEmailComponent,
    SolutionActionTextComponent,
    SolutionActionConfirmationComponent,
    SolutionActionFormComponent,
    ServiceRequestOverviewComponent,
    ViewServiceRequestComponent,
    ManageRequestReplyComponent,
    SelectSolutionComponent,
    ReplyStepComponent,
    ReplyStepFormComponent,
    ReplyStepConfirmationComponent,
    ReplyStepEmailComponent,
    ReplyStepTextComponent,
    ReplyStepInvoiceComponent,
    ReplyStepPackagingLabelComponent,
    ReplyStepReorderComponent,
    DealerViewServiceRequestComponent,
    ManageRequestReplyDealerComponent,
    DealerReplyStepComponent,
    DealerReplyStepConfirmationComponent,
    DealerReplyStepFormComponent,
    DealerReplyStepInvoiceComponent,
    DealerReplyStepPackagingLabelComponent,
    DealerReplyStepTextComponent,
    DealerReplyStepReorderComponent,
    GeneratePackagingLabelComponent,
    GenerateInvoiceComponent,
    SolutionActionChangeStatusComponent,
    ReplyStepChangeStatusComponent,
    CollectionTransportationCostComponent,
    ColliesFormComponent,
    AccountSettingComponent,
    ManageDisclaimerComponent,
    DisclaimerOverviewComponent,
    ManageWorkFormItemComponent,
    WorkFormItemOverviewComponent,
    ManagePartsComponent,
    PartsOverviewComponent,
    ArchivePartsViewComponent,
  ],
  imports: [
    BrowserModule,
    FileUploadModule,
    BrowserAnimationsModule,
    FormsModule,
    SimpleNotificationsModule.forRoot(),
    NgSelectModule,
    ReactiveFormsModule,
    FormlyModule.forRoot({
      extras: {
        checkExpressionOn: 'changeDetectionCheck',
        lazyRender: false,
        resetFieldOnHide: false,
      },
      validators: [
        {name: 'lowerCase', validation: lowercaseValidator },
        {name: 'uppercase', validation: uppercaseValidator },
        {name: 'number', validation: numberValidator },
        {name: 'special', validation: specialValidator },
      ],
      validationMessages: [
        {name: 'required', message: requiredValidationMessages},
        {name: 'minLength', message: minlengthValidationMessages},
        {name: 'maxLength', message: maxlengthValidationMessages},
      ],
      types: [
        {
          name: 'button',
          component: FormlyFieldButton,
          defaultOptions: {
            templateOptions: {
              btnType: 'default',
              type: 'button',
            },
          },
        },
        {
          name: 'ng-select',
          component: FormlyFieldNgSelectComponent,
          defaultOptions: {
            templateOptions: {
              multiple: false,
              bindValue: 'value',
              bindLabel: 'label',
            }
          }
        },
        {
          name: 'file-uploader',
          component: FileUploaderFormlyComponent
        },
        {
          name: 'editor',
          component: EditorFormlyComponent
        }
      ],
    }),
    FormlyBootstrapModule,
    NgxDatatableModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
    }),
    SharedModule,
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote', 'code-block'],
          [{ 'header': 1 }, { 'header': 2 }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'script': 'sub'}, { 'script': 'super' }],
          [{ 'indent': '-1'}, { 'indent': '+1' }],
          [{ 'direction': 'rtl' }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'font': [] }],
          [{ 'align': [] }],
          ['clean'],
          ['link', 'image', 'video']
        ]
      }
    }),
    RecaptchaV3Module,
    LoadingBarHttpClientModule,
    NgIdleKeepaliveModule.forRoot(),
    SweetAlert2Module.forRoot(),
    NgbModule
  ],
  schemas: [],
  providers: [
    StorageService,
    AuthenticationService,
    BroadcastService,
    CurrencyPipe,
    DateService,
    DomainService,
    EmailService,
    CountryService,
    Helper,
    LanguageService,
    LocalizationService,
    MenuItems,
    ToastService,
    TranslateService,
    TranslationService,
    UsersService,
    DealersService,
    CollectionService,
    DownloadService,
    ModelService,
    ProductService,
    SubProductService,
    TranslationFormlyService,
    TaxService,
    OrderService,
    PropertyService,
    FabricCollectionService,
    FabricService,
    FabricColorService,
    DownloadFilesService,
    SupplierService,
    OptionService,
    BackOfficeOrderService,
    BackOfficeInvoiceService,
    InvoiceService,
    DealerTypeService,
    GeneralTermService,
    CreditInvoiceService,
    StyleService,
    TmsLogService,
    PackagingLabelService,
    InternalPackagingLabelService,
    OrderLogService,
    DealerDashboardService,
    DashboardService,
    DataTableService,
    InvoiceLayoutService,
    DealerProfileService,
    ExactLogService,
    ServiceSubjectService,
    ServiceSubjectItemService,
    ServiceRequestService,
    SolutionService,
    CookieManagerService,
    DisclaimerService,
    WorkFormItemService,
    ContactFunctionService,
    PartsService,
    {provide: LOCALE_ID, useValue: 'en'},
    {provide: ErrorHandler, useClass: SentryErrorHandler},
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey,
    },
    /**
     * With environment.recaptchaEnabled explicitly false, ReCaptchaV3Service is replaced by a
     * stub that hands back a placeholder token. Five components call execute('login') - login,
     * the login modal, verify-code, forget-password and AuthenticationService - and swapping
     * the one provider covers all of them without a flag check in each.
     *
     * Why it exists: the API verifies every login against Google with no dev bypass, so a site
     * key that does not list localhost makes a local environment impossible to log into. Pair
     * it with a server-side stub; the token itself is never inspected by anything else.
     *
     * The flag is optional and absent from every committed environment file, so this factory
     * returns the real service everywhere except a machine that has deliberately opted out.
     */
    // Used to check only environment.recaptchaEnabled (local machines); now also feature-environment hosts.
    ...(recaptchaDisabled
      ? [{provide: ReCaptchaV3Service, useValue: {execute: () => of('recaptcha-disabled-locally')}}]
      : []),
    {
      provide: RECAPTCHA_LOADER_OPTIONS,
      useFactory: (locale: string) => ({
        onBeforeLoad(url) {
          url.searchParams.set("en", locale);

          return { url };
        },
      }),
      deps: [LOCALE_ID],
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptorService,
      multi: true
    },
    { provide: TreeviewI18n, useClass: DefaultTreeviewI18n },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
